import { getProductFlowConfiguration } from '@flows/configs/shared/flowConfiguration'
import type { FlowConfigProps, StepConfigParams } from '@flows/configs/types'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'
import { generateGetFlowValueFunctions } from '@flows/insurance/utils'

import schema from './schema'
import getLiabilityNxtSteps from './steps'

const getLiabilityConfig = ({
  clientHelpers,
  subFlow = SubFlow.LiabilityNxt,
  market,
}: FlowConfigProps) => {
  const productKey = 'liability_v1_getsafe_de'

  const params = {
    clientHelpers,
    productKey,
    helperFunctions: generateGetFlowValueFunctions(productKey),
    subFlow,
    market,
  } satisfies StepConfigParams

  const FIRST_STEP_NAME = 'liability_deductibles'
  const steps = getLiabilityNxtSteps(params)
  return getProductFlowConfiguration(productKey, steps, {
    constants: {
      FIRST_STEP_NAME,
      SCHEMA: schema,
    },
    getInitialValues: () => ({
      [productKey]: {
        productKey,
        configuration_parameters: {
          tariff_line: 'premium',
          family_coverage: false,
          drones_coverage: false,
          deductible_amount: 0,
        },
      },
    }),
  })
}

export default getLiabilityConfig
